export const viewDealTranslations = {
  en: {
    dealDetails: "Deal Details",
    dealOverview: "Overview of the deal proposal",
    withdrawn: "Withdrawn",
    unknownUser: "Unknown User",
    noEmail: "No email provided",
    dealAccepter: "Deal accepter",
    dealSummary: "Deal Summary",
    downloadReceipt: "Download Receipt",
    noFormData: "No form data",
    noSummaryData: "No summary data",
    notSpecified: "Not specified",
    yes: "Yes",
    no: "No",
    dealInfo: "Deal Information",
    dealType: "Deal Type",
    price: "Price",
    eventDate: "Event Date",
    location: "Location",
    sport: "Sport",
    weightClass: "Weight Class",
    level: "Level",
    additionalInfo: "Additional Information",
    dealMessage: "Deal Message",
    notes: "Notes",
    additionalMessage: "Additional Message",
    attachments: "Attachments",
    close: "Close",
    downloadAgreement: "Download Agreement",
    agreement: "Hoowlr Agreement",
    dealStatus: "Deal Status",
    invoiceSummary: "Invoice Summary",
    generateInvoice: "Generate Invoice",
    invoice: "Invoice",
    generating: "Generating...",
    general: "General",
    progress: "Progress",
    result: "Result",
    activity: "Activity",
    progressStatusProposed: "Proposed",
    progressStatusAccepted: "Accepted",
    progressStatusPaymentConfirmed: "Payment Confirmed",
    progressStatusWaitingForResult: "Waiting For Result",
    progressStatusResultUpdated: "Result Updated",
    progressStatusFighterRated: "Fighter Rated",
    progressStatusResultConfirmed: "Result Confirmed",
    progressStatusManagerRated: "Manager Rated",
    progressStatusFinished: "Finished",
    progressStatusDisputed: "Disputed",
    progressStatusCancelled: "Cancelled",
    progressStatusRejected: "Rejected",
    progressStatusPrePaymentReleased: "Pre Payment Released",
    progressStatusPostPayment: "Post Payment",
    progressStatusPostPaymentReleased: "Post Payment Released",
    progressStatusPaymentRefunded: "Payment Refunded",
    progressStatusExpired: "Expired",
    progressActionAcceptOrDeclineDeal: "Accept Or Decline Deal",
    progressActionConfirmPayment: "Confirm Payment",
    progressActionUpdateResult: "Update Result",
    progressActionConfirmResult: "Confirm Result",
    progressActionSubmitRating: "Submit Rating",
    progressActionReleasePayment: "Release Payment",
    progressActionProcessPostPayment: "Process Post Payment",
    systemUser: "System",
    noActivityForStep: "No activity for this step",
    noActivityYet: "No activity yet",
    dealRejected: "This deal was rejected.",
    componentPayments: "Component Payments",
    noComponentPayments: "No component payments",
    payment: "Payment",
    preEvent: "Pre-Event",
    postEvent: "Post-Event",
    percentOfBase: "{{value}}% of Base",
    fixed: "Fixed",
    baseAmount: "Base Amount",
    BASE_AMOUNT: "Base Amount",
    postEventPaymentNote: "Note: As per the result policies, the amount will change.",
    dueDate: "Due Date",
    paymentStatusPending: "Pending",
    paymentStatusCancelled: "Cancelled",
    paymentStatusPaid: "Paid",
    processing: "Processing...",
    collapse: "Collapse",
    expand: "Expand",
    noBreakdownAvailable: "No breakdown available",
    noPaymentsForTiming: "No payments for this timing",
    Bonus: "Bonus",
    Pay: "Pay",
    cannotPayUntilAccepted: "Cannot pay until deal is accepted",
    downloadDocuments:"Download Deal Overview Summary",
    rateThisDeal: "Rate this Deal",
    feedback: "Feedback (max 500 characters)",
    pleaseSelectRating: "Please select a rating",
    pleaseProvideRating: "Please provide a rating and confirm the result",
    youHaveRated: "You have already rated this deal",
    submitRatingOnly: "Submit Rating Only",
    submitRating: "Submit Rating",
    later: "Later",
    ratingSubmitted: "Rating submitted successfully!",
    fightResult: "Fight Result",
    win: "Win",
    loss: "Loss",
    draw: "Draw",
    noShowFault: "No show - fault",
    noShowMedical: "No show - medical",
    eventCancelled: "Event cancelled",
    opponentNoShow: "Opponent no-show",
    bonus: "Bonus",
    selectResult: "Select Result",
    noResultYet: "Waiting for Manager Result",
    submitResultOnly: "Submit Result",
    submitResult: "Submit My Result",
    resultSubmitted: "Result Submitted",
    fillyourdespuit: "Fill your dispute form",
    yourFightResult: "Fight Result",
    description: "Description",
    explainWhatHappened: "Explain what happened...",
    resultUpdated: "Fight result updated!",
    confirmResult: "Yes, I Accepted",
    managerConfirmed:"Manager confirmed the result",
    fighterConfirmed: "Fighter confirmed the result",
    manager: "Manager",
    fighter: "Fighter",
    submitDispute:"Submit Dispute",
    disputeSubtitle: "If you disagree with the result, please submit a dispute. Our team will review the case and make a final decision.",
    submitMyResult: "Submit My Result",
    selectResultToSeeAmount: "Select result to see amount",
    chooseOutcome: "Choose the fight outcome to view payout amounts",
    refundAmount: "Refund Amount",
    currentResult: "Current Result",
    earnings: "Earnings",
    total: "Total",
    breakdown: "Breakdown",
    note: "Note",
    halfBaseAppliedNote: "50% of base amount applied.",
    shareYourExperience: "Share your experience...",
    selectYourResult: "Select Your Result",
    drawPayoutWarning: "Selecting Draw means the payout will be 50% of the base amount (half base). Bonus components will not be applied.",
    evidence: "Evidence",
    optional: "Optional",
    charsCount: "{{count}} Chars",
    filesAttached: "{{count}} File(s) Attached",
    attachImagesOrVideos: "Attach Images Or Videos",
    attachImages: "Attach Images",
    supportedEvidenceFormats: "JPG, PNG, MP4 Supported",
    supportedEvidenceFormatsWithoutVideo: "JPG, PNG Supported",
    anonymous: "Anonymous",
    noRatingsYet: "No ratings yet",
    feedbackRequired: "Feedback is required",
    failedToUpdateResult: "Failed to update result",
    failedToConfirmResult: "Failed to confirm result",
    failedToSubmitDispute: "Failed to submit dispute",
    failedToSubmitRating: "Failed to submit rating",
    ratingPoor: "Poor",
    ratingFair: "Fair",
    ratingGood: "Good",
    ratingVeryGood: "Very good",
    ratingExcellent: "Excellent",
    componentLabels: {
      BASE_AMOUNT: "Base Amount",
      PERFORMANCE_BONUS: "Performance bonus",
      SIGNING_BONUS: "Signing bonus",
      TRAVEL_ALLOWANCE: "Travel allowance",
      APPEARANCE_FEE: "Appearance fee",
      WIN_BONUS: "Win bonus",
      FIGHT_FEE: "Fight fee",
      TRAVEL_EXPENSE: "Travel expense",
      ON_WEIGHT_BONUS: "On weight bonus",
    },
    paymentTiming: {
      pre_event: "Pre-event",
      post_event: "Post-event",
    },
    payoutTypes: {
      full: {
        text: "Full payout",
        hint: "All components applied",
      },
      base_only: {
        text: "Base only",
        hint: "Bonus components excluded",
      },
      half_base: {
        text: "Half base",
        hint: "50% of base amount applied",
      },
      partial: {
        text: "Partial payout",
        hint: "Some components excluded",
      },
      none: {
        text: "No payout",
        hint: "No amount released",
      },
    },
    payoutSelectionModes: {
      BASE_PLUS_SELECTED_COMPONENTS: "Base plus selected components",
      SELECTED_COMPONENTS_ONLY: "Selected components only",
    },
    cancel: "Cancel",
    rejectresult: "No, I Decline",
    giveRating: "Give Ratings",
    resultConfirmed: "Result confirmed!",
    disputeSubmitted: "Dispute Submited",
    bothConfirmed: "Both parties confirmed the result",
    resultAlreadySet: "Result already submitted",
    howWasYourExperience: "How was your experience?",
    fightResultAndRating: "Fight Result",
    ratingsReceived: "Ratings Received",
    ratings: "Ratings",
    activityLog: "Activity Log",
 
    completeAllFields: "Please complete all required fields",
    resultAndRatingSubmitted: "Result and rating submitted successfully!",
    submissionFailed: "Submission failed. Please try again.",
    downloadFailed: "Download failed. Please try again.",
 
    noResult: "No Result",
    failedToRefreshDeal: "Failed to refresh deal",
    paymentSuccessful: "Payment successful!",
    failedToLoadDeal: "Failed to load deal",
    failedToGenerateInvoice: "Failed to generate invoice",
    noPaymentReceiptAvailable: "No payment receipt available",
    failedToDownloadAgreement: "Failed to download agreement",
    paymentNotAvailableForCheckout: "This payment is not available for checkout",
    checkoutUrlNotAvailable: "Checkout URL not available",
    componentPaymentFailed: "Component payment failed",
    dealNotFound: "Deal not found",
    back: "Back",
    coreInformation: "Core Information",
    fightDetails: "Fight Details",
    dealNotes: "Deal Notes",
    currency: "Currency",
    paymentMode: "Payment Mode",
    opponent: "Opponent",
    numberOfRounds: "Number of Rounds",
    ruleset: "Ruleset",
    componentType: "Component Type",
    calculationMode: "Calculation Mode",
    roundDuration: "Round Duration",
    titleFight: "Title Fight",
    upfront: "Upfront",
    split: "Split",
    // --- Activity i18n Templates (English) ---
    activity_PROPOSED: "has proposed a deal (Deal ID <b>{{0}}</b>) for sport <b>{{1}}</b> with base amount <b>{{2}}</b> and currency <b>{{3}}</b>",
    activity_ACCEPTED: "has accepted the deal (Deal ID <b>{{0}}</b>) with base amount <b>{{1}}</b> currency <b>{{2}}</b>",
    activity_REJECTED: "has rejected the deal (Deal ID <b>{{0}}</b>) with base amount <b>{{1}}</b> currency <b>{{2}}</b>",
    activity_CANCELLED: "Deal has been cancelled.",
    activity_CONFIRMED: "Pre-match payment has been completed. Deal is now confirmed.",
    activity_WAITING_FOR_RESULT: "Deal has moved to waiting for fight result.",
    activity_RESULT_UPDATED: "has updated the fight result for Deal ID <b>{{0}}</b> <b>{{1}}</b>",
    activity_RESULT_CONFIRMED: "has updated the fight result for Deal ID <b>{{0}}</b> <b>{{1}}</b>. Fighter has {{2}} the result.",
    activity_DISPUTE: "has disputed the fight result for Deal ID <b>{{0}}</b> <b>{{1}}</b>",
    activity_POST_PAYMENT: "Post-event payment has been completed.",
    activity_FIGHTER_RATED: "Fighter has submitted their rating for Deal ID <b>{{0}}</b>",
    activity_MANAGER_RATED: "Manager has submitted their rating for Deal ID <b>{{0}}</b>",
    activity_FINISHED: "Deal has been completed. All payments have been processed.",
    activity_PRE_PAYMENT_RELEASED: "Pre-match payment of <b>{{0}}</b> <b>{{1}}</b> has been released to the fighter.",
    activity_PAYMENT_REFUNDED: "Amount of <b>{{0}}</b> <b>{{1}}</b> has been refunded to the manager from the pre-match payment.",
    activity_POST_PAYMENT_RELEASED: "Post-match payment of <b>{{0}}</b> <b>{{1}}</b> has been released to the fighter.",
    // Pending Messages (en)
    activity_ACCEPTED_PENDING: "Fighter must accept the deal before the deadline",
    activity_CONFIRMED_PENDING: "Manager must confirm the deal before the deadline",
    activity_RESULT_UPDATED_PENDING: "Manager must update the fight result before the deadline",
    activity_RESULT_CONFIRMED_PENDING: "Fighter must confirm the fight result before the deadline",
    activity_POST_PAYMENT_PENDING: "Post-event payment is pending release",
    activity_FIGHTER_RATED_PENDING: "Fighter must submit rating before the deadline",
    activity_MANAGER_RATED_PENDING: "Manager must submit rating before the deadline",
    // System / Auto Messages (en)
    activity_CANCELLED_DEADLINE_FIGHTER: "Deal cancelled automatically — fighter did not accept before the deadline.",
    activity_CANCELLED_PRE_PAYMENT_OVERDUE: "Deal cancelled — pre-match payment was not completed by the due date.",
    activity_SYSTEM_PAYMENT_RELEASED: "Payment for <b>{{0}}</b> was automatically released by the system.",
    activity_FINISHED_AUTO_DEADLINE: "Deal closed automatically — deadline for stage <b>{{0}}</b> was crossed. All pending payments have been released.",
    activity_FINISHED_POST_UNPAID: "Deal closed — post-match payment was not received. Pre-match payment has been released to the fighter.",

    // Document Requirement section
    documentRequirement: "Document Requirement",
    documentType: "Document Type",
    submissionDeadline: "Submission Deadline",
    additionalNotesOptional: "Additional Notes (optional)",
    uploadStatus: "Upload Status",
    uploadedDocument: "Uploaded Document",
    uploadRequiredDocument: "Upload required document",
    chooseFileAndUploadForDeal: "Choose a file and upload it for this deal.",
    selectedFile: "Selected file",
    remove: "Remove",
    pendingUpload: "Pending Upload",
    uploaded: "Uploaded",
    deadlineMissed: "Deadline Missed",
    pleaseChooseFileFirst: "Please choose a file first.",
    dealIdMissing: "Deal id is missing.",
    documentUploadNotAllowed: "Document upload is only allowed for the deal accepter while the deal is still in PROPOSED status (documents must be uploaded before you can accept the deal).",
    documentUploadedSuccessfully: "Document uploaded successfully.",
    unableToUploadDocument: "Unable to upload document.",
    onlyPdfAllowed: "Only PDF files are allowed for this document.",
    uploadingFile: "Uploading...",
    uploadButton: "Upload",

    // Bonuses, Expenses & Penalties section
    "Bonuses, Expenses & Penalties": "Bonuses, Expenses & Penalties",
    "Payout Policies": "Payout Policies",
    category: "Category",
    value: "Value",
    fundingStage: "Funding Stage",
    expenseDescription: "Expense Description",
    "Expense": "Expense",
    "Penalty": "Penalty",

    // componentType options
    "Win Bonus": "Win Bonus",
    "Performance Bonus": "Performance Bonus",
    "Fight of the Night": "Fight of the Night",
    "Performance of the Night": "Performance of the Night",
    "Knockout of the Night": "Knockout of the Night",
    "Submission of the Night": "Submission of the Night",
    "On-Weight Bonus": "On-Weight Bonus",
    "Media & Promo Bonus": "Media & Promo Bonus",
    "Ticket Sales Commission": "Ticket Sales Commission",
    "PPV Share": "PPV Share",
    "Locker Room Bonus": "Locker Room Bonus",
    "Travel Expense": "Travel Expense",
    "Per Diem Expense": "Per Diem Expense",
    "Late Penalty": "Late Penalty",

    // calculation mode options
    "Fixed Amount": "Fixed Amount",
    "Percentage of Base Amount": "Percentage of Base Amount",

    // funding stage options
    "Pre Event": "Pre Event",
    "Post Event": "Post Event",

    // Payout Policies outcome labels
    "Win": "Win",
    "Draw": "Draw",
    "Loss": "Loss",
    "No-Show Fault": "No-Show Fault",
    "No-Show Medical": "No-Show Medical",
    "Event Cancelled": "Event Cancelled",
    "Opponent No-Show": "Opponent No-Show",

    // Payout Policies selection mode display values
    "Base Plus Selected Components": "Base Plus Selected Components",
    "Selected Components Only": "Selected Components Only",

  },
 
  de: {
    fillyourdespuit: "Füllen Sie Ihr Streitformular aus",
    dealDetails: "Deal-Details",
    dealOverview: "Übersicht über den Deal-Vorschlag",
    withdrawn: "Zurückgezogen",
    unknownUser: "Unbekannter Benutzer",
    noEmail: "Keine E-Mail angegeben",
    dealAccepter: "Deal-Annehmer",
    BASE_AMOUNT: "Basisbetrag",
    dealSummary: "Deal-Zusammenfassung",
    downloadReceipt: "Beleg herunterladen",
    noFormData: "Keine Formulardaten",
    noSummaryData: "Keine Zusammenfassungsdaten",
    notSpecified: "Nicht angegeben",
    yes: "Ja",
    no: "Nein",
    dealInfo: "Deal-Informationen",
    dealType: "Deal-Typ",
    price: "Preis",
    eventDate: "Veranstaltungsdatum",
    location: "Ort",
    sport: "Sport",
    weightClass: "Gewichtsklasse",
    level: "Niveau",
    additionalInfo: "Zusätzliche Informationen",
    dealMessage: "Deal-Nachricht",
    notes: "Notizen",
    additionalMessage: "Zusätzliche Nachricht",
    attachments: "Anhänge",
    close: "Schließen",
    downloadAgreement: "Vereinbarung herunterladen",
    agreement: "Hoowlr-Vereinbarung",
    dealStatus: "Deal-Status",
 
    general: "Allgemein",
    componentPayments: "Komponenten Zahlungen",
    noComponentPayments: "Keine Komponentenzahlungen",
    payment: "Zahlung",
    preEvent: "Vor dem Event",
    postEvent: "Nach dem Event",
    percentOfBase: "{{value}}% des Basisbetrags",
    fixed: "Festbetrag",
    baseAmount: "Basisbetrag",
    postEventPaymentNote: "Hinweis: Gemäß den Ergebnisrichtlinien kann sich der Betrag ändern.",
    dueDate: "Fälligkeitsdatum",
    paymentStatusPending: "Ausstehend",
    paymentStatusCancelled: "Storniert",
    paymentStatusPaid: "Bezahlt",
    processing: "Wird verarbeitet...",
    collapse: "Einklappen",
    expand: "Erweitern",
    noBreakdownAvailable: "Keine Aufschlüsselung verfügbar",
    noPaymentsForTiming: "Keine Zahlungen für diesen Zeitpunkt",
    Pay: "Bezahlen",
    progress: "Fortschritt",
    result: "Ergebnis",
    activity: "Aktivität",
    progressStatusProposed: "Vorgeschlagen",
    progressStatusAccepted: "Akzeptiert",
    progressStatusPaymentConfirmed: "Zahlung bestätigt",
    progressStatusWaitingForResult: "Warten auf Ergebnis",
    progressStatusResultUpdated: "Ergebnis aktualisiert",
    progressStatusFighterRated: "Kämpfer bewertet",
    progressStatusResultConfirmed: "Ergebnis bestätigt",
    progressStatusManagerRated: "Manager bewertet",
    progressStatusFinished: "Abgeschlossen",
    progressStatusDisputed: "Angefochten",
    progressStatusCancelled: "Storniert",
    progressStatusRejected: "Abgelehnt",
    progressStatusPrePaymentReleased: "Vorabzahlung freigegeben",
    progressStatusPostPayment: "Nachzahlung",
    progressStatusPostPaymentReleased: "Nachzahlung freigegeben",
    progressStatusPaymentRefunded: "Zahlung erstattet",
    progressStatusExpired: "Abgelaufen",
    progressActionAcceptOrDeclineDeal: "Deal akzeptieren oder ablehnen",
    progressActionConfirmPayment: "Zahlung bestätigen",
    progressActionUpdateResult: "Ergebnis aktualisieren",
    progressActionConfirmResult: "Ergebnis bestätigen",
    progressActionSubmitRating: "Bewertung senden",
    progressActionReleasePayment: "Zahlung freigeben",
    progressActionProcessPostPayment: "Nachzahlung verarbeiten",
    systemUser: "System",
    noActivityForStep: "Keine Aktivität für diesen Schritt",
    noActivityYet: "Noch keine Aktivität",
    dealRejected: "Dieser Deal wurde abgelehnt.",
 
    rateThisDeal: "Diesen Deal bewerten",
    optionalFeedback: "Optionales Feedback (max. 500 Zeichen)",
    pleaseSelectRating: "Bitte wähle eine Bewertung aus",
    pleaseProvideRating:
      "Bitte gib eine Bewertung ab und bestätige das Ergebnis",
    youHaveRated: "Du hast diesen Deal bereits bewertet",
    submitRatingOnly: "Nur Bewertung abschicken",
    submitRating: "Bewertung abschicken",
    later: "Später",
    ratingSubmitted: "Bewertung erfolgreich abgegeben!",
 
    fightResult: "Kampfergebnis",
    win: "Sieg",
    loss: "Niederlage",
    draw: "Unentschieden",
    noShowFault: "Nicht erschienen - Verschulden",
    noShowMedical: "Nicht erschienen - medizinisch",
    eventCancelled: "Event abgesagt",
    opponentNoShow: "Gegner nicht erschienen",
    bonus: "Bonus",
    selectResult: "Ergebnis auswählen",
    noResultYet: "Noch kein Ergebnis eingetragen",
    submitResultOnly: "Nur Kampfergebnis einreichen",
    submitResult: "Ergebnis einreichen",
    resultSubmitted: "Ergebnis eingereicht",
    submitYourFightResult: "Dein Kampfergebnis einreichen",
    yourFightResult: "Dein Kampfergebnis",
    description: "Beschreibung",
    feedback: "Feedback (max. 500 Zeichen)",
    managerConfirmed: "Manager hat das Ergebnis bestätigt",
    fighterConfirmed: "Kämpfer hat das Ergebnis bestätigt",
    manager: "Manager",
    fighter: "Kämpfer",
    submitDispute: "Einspruch einreichen",
    disputeSubtitle: "Wenn du mit dem Ergebnis nicht einverstanden bist, reiche bitte einen Einspruch ein. Unser Team prüft den Fall und trifft eine endgültige Entscheidung.",
    submitMyResult: "Mein Ergebnis einreichen",
    selectResultToSeeAmount: "Ergebnis auswählen, um den Betrag zu sehen",
    refundAmount: "Erstattungsbetrag",
    currentResult: "Aktuelles Ergebnis",
    earnings: "Einnahmen",
    total: "Gesamt",
    breakdown: "Aufschlüsselung",
    note: "Hinweis",
    halfBaseAppliedNote: "50% des Basisbetrags angewendet.",
    shareYourExperience: "Teile deine Erfahrung...",
    selectYourResult: "Wähle dein Ergebnis",
    drawPayoutWarning: "Bei Unentschieden werden 50% des Basisbetrags ausgezahlt. Bonus-Komponenten werden nicht angewendet.",
    evidence: "Nachweise",
    optional: "Optional",
    charsCount: "{{count}} Zeichen",
    filesAttached: "{{count}} Datei(en) angehängt",
    attachImagesOrVideos: "Bilder oder Videos anhängen",
    attachImages: "Bilder anhängen",
    supportedEvidenceFormats: "JPG, PNG, MP4 unterstützt",
    supportedEvidenceFormatsWithoutVideo: "JPG, PNG unterstützt",
    explainWhatHappened: "Erkläre, was passiert ist...",
    resultUpdated: "Kampfergebnis aktualisiert!",
    confirmResult: "Ja, ich bestätige",
    rejectresult: "Nein, ich lehne ab",
    giveRating: "Bewertung abgeben",
    resultConfirmed: "Ergebnis bestätigt!",
    disputeSubmitted: "Einspruch eingereicht",
    bothConfirmed: "Beide Parteien haben das Ergebnis bestätigt",
    resultAlreadySet: "Ergebnis wurde bereits eingereicht",
    chooseOutcome: "Wähle den Kampfausgang aus, um die Auszahlungsbeträge zu sehen",
 
    anonymous: "Anonym",
    noRatingsYet: "Noch keine Bewertungen",
    feedbackRequired: "Feedback ist erforderlich",
    failedToUpdateResult: "Ergebnis konnte nicht aktualisiert werden",
    failedToConfirmResult: "Ergebnis konnte nicht bestÃ¤tigt werden",
    failedToSubmitDispute: "Einspruch konnte nicht eingereicht werden",
    failedToSubmitRating: "Bewertung konnte nicht gesendet werden",
    ratingPoor: "Schlecht",
    ratingFair: "Okay",
    ratingGood: "Gut",
    ratingVeryGood: "Sehr gut",
    ratingExcellent: "Ausgezeichnet",
    componentLabels: {
      BASE_AMOUNT: "Basisbetrag",
      PERFORMANCE_BONUS: "Leistungsbonus",
      SIGNING_BONUS: "Signing-Bonus",
      TRAVEL_ALLOWANCE: "Reisezuschuss",
      APPEARANCE_FEE: "Auftrittsgage",
      WIN_BONUS: "Siegbonus",
      FIGHT_FEE: "Kampfgage",
      TRAVEL_EXPENSE: "Reisekosten",
      ON_WEIGHT_BONUS: "Gewichtsbonus",
      TICKET_COMMISSION: "Ticketprovision",
    },
    paymentTiming: {
      pre_event: "Vor dem Event",
      post_event: "Nach dem Event",
    },
    payoutTypes: {
      full: {
        text: "Volle Auszahlung",
        hint: "Alle Komponenten angewendet",
      },
      base_only: {
        text: "Nur Basisbetrag",
        hint: "Bonus-Komponenten ausgeschlossen",
      },
      half_base: {
        text: "Halber Basisbetrag",
        hint: "50% des Basisbetrags angewendet",
      },
      partial: {
        text: "Teilauszahlung",
        hint: "Einige Komponenten ausgeschlossen",
      },
      none: {
        text: "Keine Auszahlung",
        hint: "Kein Betrag freigegeben",
      },
    },
    payoutSelectionModes: {
      BASE_PLUS_SELECTED_COMPONENTS: "Basis plus ausgewÃ¤hlte Komponenten",
      SELECTED_COMPONENTS_ONLY: "Nur ausgewÃ¤hlte Komponenten",
    },
    cancel: "Abbrechen",
    ratings: "Bewertungen",
    howWasYourExperience: "Wie war deine Erfahrung?",
    fightResultAndRating: "Kampfergebnis",
    ratingsReceived: "Erhaltene Bewertungen",
 
    activityLog: "Aktivitätsprotokoll",
 
    completeAllFields: "Bitte alle Pflichtfelder ausfüllen",
    resultAndRatingSubmitted: "Ergebnis und Bewertung erfolgreich eingereicht!",
    submissionFailed: "Übermittlung fehlgeschlagen. Bitte versuche es erneut.",
    downloadFailed: "Download fehlgeschlagen. Bitte versuche es erneut.",
 
    noResult: "Kein Ergebnis",
    failedToRefreshDeal: "Deal konnte nicht aktualisiert werden",
    paymentSuccessful: "Zahlung erfolgreich!",
    failedToLoadDeal: "Deal konnte nicht geladen werden",
    failedToGenerateInvoice: "Rechnung konnte nicht erstellt werden",
    noPaymentReceiptAvailable: "Kein Zahlungsbeleg verfügbar",
    failedToDownloadAgreement: "Vereinbarung konnte nicht heruntergeladen werden",
    paymentNotAvailableForCheckout: "Diese Zahlung ist nicht für den Checkout verfügbar",
    checkoutUrlNotAvailable: "Checkout-URL nicht verfügbar",
    componentPaymentFailed: "Komponentenzahlung fehlgeschlagen",
    dealNotFound: "Deal nicht gefunden",
    back: "Zurück",
    coreInformation: "Kerninformationen",
fightDetails: "Kampfdetails",
dealNotes: "Deal-Notizen",
currency: "Währung",
paymentMode: "Zahlungsmodus",
opponent: "Gegner",
numberOfRounds: "Anzahl der Runden",
ruleset: "Regelwerk",
componentType: "Komponententyp",
calculationMode: "Berechnungsmodus",
roundDuration: "Rundendauer",
titleFight: "Titelkampf",
upfront: "Vorab",
split: "Aufgeteilt",
 activity_PROPOSED: "hat einen Deal vorgeschlagen (Deal-ID <b>{{0}}</b>) für Sport <b>{{1}}</b> mit Basisbetrag <b>{{2}}</b> und Währung <b>{{3}}</b>",
    activity_ACCEPTED: "hat den Deal (Deal-ID <b>{{0}}</b>) mit Basisbetrag <b>{{1}}</b> Währung <b>{{2}}</b> akzeptiert",
    activity_REJECTED: "hat den Deal (Deal-ID <b>{{0}}</b>) mit Basisbetrag <b>{{1}}</b> Währung <b>{{2}}</b> abgelehnt",
    activity_CANCELLED: "Der Deal wurde storniert.",
    activity_CONFIRMED: "Die Vorab-Zahlung wurde abgeschlossen. Der Deal ist jetzt bestätigt.",
    activity_WAITING_FOR_RESULT: "Deal wartet auf das Kampfergebnis.",
    activity_RESULT_UPDATED: "hat das Kampfergebnis für Deal-ID <b>{{0}}</b> aktualisiert <b>{{1}}</b>",
    activity_RESULT_CONFIRMED: "hat das Kampfergebnis für Deal-ID <b>{{0}}</b> aktualisiert <b>{{1}}</b>. Der Kämpfer hat das Ergebnis {{2}}.",
    activity_DISPUTE: "hat das Kampfergebnis für Deal-ID <b>{{0}}</b> angefochten <b>{{1}}</b>",
    activity_POST_PAYMENT: "Die Zahlung nach der Veranstaltung wurde abgeschlossen.",
    activity_FIGHTER_RATED: "Der Kämpfer hat seine Bewertung für Deal-ID <b>{{0}}</b> abgegeben",
    activity_MANAGER_RATED: "Der Manager hat seine Bewertung für Deal-ID <b>{{0}}</b> abgegeben",
    activity_FINISHED: "Der Deal wurde abgeschlossen. Alle Zahlungen wurden verarbeitet.",
    activity_PRE_PAYMENT_RELEASED: "Die Vorab-Zahlung von <b>{{0}}</b> <b>{{1}}</b> wurde an den Kämpfer freigegeben.",
    activity_PAYMENT_REFUNDED: "Betrag von <b>{{0}}</b> <b>{{1}}</b> wurde dem Manager aus der Vorab-Zahlung erstattet.",
    activity_POST_PAYMENT_RELEASED: "Die Nachzahlung von <b>{{0}}</b> <b>{{1}}</b> wurde an den Kämpfer freigegeben.",
    // Pending Messages (de)
    activity_ACCEPTED_PENDING: "Der Kämpfer muss den Deal vor der Frist akzeptieren",
    activity_CONFIRMED_PENDING: "Der Manager muss den Deal vor der Frist bestätigen",
    activity_RESULT_UPDATED_PENDING: "Der Manager muss das Kampfergebnis vor der Frist aktualisieren",
    activity_RESULT_CONFIRMED_PENDING: "Der Kämpfer muss das Kampfergebnis vor der Frist bestätigen",
    activity_POST_PAYMENT_PENDING: "Die Zahlung nach der Veranstaltung steht noch aus",
    activity_FIGHTER_RATED_PENDING: "Der Kämpfer muss die Bewertung vor der Frist abgeben",
    activity_MANAGER_RATED_PENDING: "Der Manager muss die Bewertung vor der Frist abgeben",
    // System / Auto Messages (de)
    activity_CANCELLED_DEADLINE_FIGHTER: "Deal automatisch storniert — Kämpfer hat vor der Frist nicht akzeptiert.",
    activity_CANCELLED_PRE_PAYMENT_OVERDUE: "Deal storniert — Vorab-Zahlung wurde nicht bis zum Fälligkeitsdatum abgeschlossen.",
    activity_SYSTEM_PAYMENT_RELEASED: "Zahlung für <b>{{0}}</b> wurde automatisch vom System freigegeben.",
    activity_FINISHED_AUTO_DEADLINE: "Deal automatisch abgeschlossen — Frist für Phase <b>{{0}}</b> wurde überschritten. Alle ausstehenden Zahlungen wurden freigegeben.",
    activity_FINISHED_POST_UNPAID: "Deal abgeschlossen — Nachzahlung wurde nicht erhalten. Vorab-Zahlung wurde an den Kämpfer freigegeben.",

    // Document Requirement section
    documentRequirement: "Dokumentenanforderung",
    documentType: "Dokumenttyp",
    submissionDeadline: "Einreichungsfrist",
    additionalNotesOptional: "Zusätzliche Hinweise (optional)",
    uploadStatus: "Upload-Status",
    uploadedDocument: "Hochgeladenes Dokument",
    uploadRequiredDocument: "Erforderliches Dokument hochladen",
    chooseFileAndUploadForDeal: "Wählen Sie eine Datei aus und laden Sie sie für diesen Deal hoch.",
    selectedFile: "Ausgewählte Datei",
    remove: "Entfernen",
    pendingUpload: "Hochladen ausstehend",
    uploaded: "Hochgeladen",
    deadlineMissed: "Frist verpasst",
    pleaseChooseFileFirst: "Bitte wählen Sie zuerst eine Datei aus.",
    dealIdMissing: "Deal-ID fehlt.",
    documentUploadNotAllowed: "Das Hochladen von Dokumenten ist nur für den Deal-Annehmer erlaubt, solange sich der Deal im Status PROPOSED befindet (Dokumente müssen hochgeladen werden, bevor Sie den Deal annehmen können).",
    documentUploadedSuccessfully: "Dokument erfolgreich hochgeladen.",
    unableToUploadDocument: "Dokument konnte nicht hochgeladen werden.",
    onlyPdfAllowed: "Für dieses Dokument sind nur PDF-Dateien zulässig.",
    uploadingFile: "Wird hochgeladen...",
    uploadButton: "Hochladen",

    // Bonuses, Expenses & Penalties section
    "Bonuses, Expenses & Penalties": "Boni, Ausgaben & Strafen",
    "Payout Policies": "Auszahlungsrichtlinien",
    category: "Kategorie",
    value: "Wert",
    fundingStage: "Finanzierungsphase",
    expenseDescription: "Ausgabenbeschreibung",

    // kind options
    "Bonus": "Bonus",
    "Expense": "Ausgabe",
    "Penalty": "Strafe",

    // componentType options
    "Win Bonus": "Sieg-Bonus",
    "Performance Bonus": "Leistungsbonus",
    "Fight of the Night": "Kampf der Nacht",
    "Performance of the Night": "Leistung der Nacht",
    "Knockout of the Night": "Knockout der Nacht",
    "Submission of the Night": "Aufgabe der Nacht",
    "On-Weight Bonus": "Gewichts-Bonus",
    "Media & Promo Bonus": "Medien- & Promo-Bonus",
    "Ticket Sales Commission": "Ticketverkaufsprovision",
    "PPV Share": "PPV-Anteil",
    "Locker Room Bonus": "Umkleidekabinen-Bonus",
    "Travel Expense": "Reisekosten",
    "Per Diem Expense": "Tagesspesen",
    "Late Penalty": "Verspätungsstrafe",

    // calculation mode options
    "Fixed Amount": "Fester Betrag",
    "Percentage of Base Amount": "Prozentsatz des Basisbetrags",

    // funding stage options
    "Pre Event": "Vor der Veranstaltung",
    "Post Event": "Nach der Veranstaltung",

    // Payout Policies outcome labels
    "Win": "Sieg",
    "Draw": "Unentschieden",
    "Loss": "Niederlage",
    "No-Show Fault": "Nichterscheinen (verschuldet)",
    "No-Show Medical": "Nichterscheinen (medizinisch)",
    "Event Cancelled": "Veranstaltung abgesagt",
    "Opponent No-Show": "Gegner nicht erschienen",

    // Payout Policies selection mode display values
    "Base Plus Selected Components": "Basis plus ausgewählte Komponenten",
    "Selected Components Only": "Nur ausgewählte Komponenten",

  },
 
  hr: {
    fillyourdespuit: "Ispunite obrazac za prigovor",
 
    dealDetails: "Detalji dogovora",
    dealOverview: "Pregled prijedloga dogovora",
    withdrawn: "Povučen",
    unknownUser: "Nepoznat korisnik",
    noEmail: "Nema e-maila",
    dealAccepter: "Prihvatitelj dogovora",
    dealSummary: "Sažetak ugovora",
    downloadReceipt: "Preuzmi potvrdu",
    noFormData: "Nema podataka obrasca",
    noSummaryData: "Nema podataka za sažetak",
    notSpecified: "Nije navedeno",
    yes: "Da",
    no: "Ne",
    dealInfo: "Informacije o dogovoru",
    dealType: "Vrsta dogovora",
    noComponentPayments: "Nema plaćanja komponenti",
    payment: "Plaćanje",
    preEvent: "Prije događaja",
    postEvent: "Nakon događaja",
    percentOfBase: "{{value}}% osnovnog iznosa",
    fixed: "Fiksni iznos",
    baseAmount: "Osnovni iznos",
    postEventPaymentNote: "Napomena: Prema pravilima rezultata, iznos se može promijeniti.",
    dueDate: "Datum dospijeća",
    paymentStatusPending: "Na čekanju",
    paymentStatusCancelled: "Otkazano",
    paymentStatusPaid: "Plaćeno",
    processing: "Obrada...",
    collapse: "Sažmi",
    expand: "Proširi",
    noBreakdownAvailable: "Nema dostupne raščlambe",
    noPaymentsForTiming: "Nema plaćanja za ovaj termin",
    Pay: "Plati",
    componentPayments: "Plaćanja komponenti",
    price: "Cijena",
    eventDate: "Datum događaja",
    location: "Lokacija",
    sport: "Sport",
    weightClass: "Težinska kategorija",
    level: "Razina",
    additionalInfo: "Dodatne informacije",
    dealMessage: "Poruka dogovora",
    notes: "Bilješke",
    additionalMessage: "Dodatna poruka",
    attachments: "Privitci",
    close: "Zatvori",
    downloadAgreement: "Preuzmi ugovor",
    agreement: "Hoowlr Ugovor",
    dealStatus: "Status dogovora",
 
    general: "Općenito",
    progress: "Napredak",
    result: "Rezultat",
    activity: "Aktivnost",
    progressStatusProposed: "Predloženo",
    progressStatusAccepted: "Prihvaćeno",
    progressStatusPaymentConfirmed: "Plaćanje potvrđeno",
    progressStatusWaitingForResult: "Čeka se rezultat",
    progressStatusResultUpdated: "Rezultat ažuriran",
    progressStatusFighterRated: "Borac ocijenio",
    progressStatusResultConfirmed: "Rezultat potvrđen",
    progressStatusManagerRated: "Menadžer ocijenio",
    progressStatusFinished: "Završeno",
    progressStatusDisputed: "Spor",
    progressStatusCancelled: "Otkazano",
    progressStatusRejected: "Odbijeno",
    progressStatusPrePaymentReleased: "Predujam pušten",
    progressStatusPostPayment: "Naknadno plaćanje",
    progressStatusPostPaymentReleased: "Naknadno plaćanje pušteno",
    progressStatusPaymentRefunded: "Plaćanje vraćeno",
    progressStatusExpired: "Isteklo",
    progressActionAcceptOrDeclineDeal: "Prihvati ili odbij dogovor",
    progressActionConfirmPayment: "Potvrdi plaćanje",
    progressActionUpdateResult: "Ažuriraj rezultat",
    progressActionConfirmResult: "Potvrdi rezultat",
    progressActionSubmitRating: "Pošalji ocjenu",
    progressActionReleasePayment: "Pusti plaćanje",
    progressActionProcessPostPayment: "Obradi naknadno plaćanje",
    systemUser: "Sustav",
    noActivityForStep: "Nema aktivnosti za ovaj korak",
    noActivityYet: "Još nema aktivnosti",
    dealRejected: "Ovaj dogovor je odbijen.",
 
    rateThisDeal: "Ocijeni ovaj dogovor",
    optionalFeedback: "Neobavezni komentar (maks. 500 znakova)",
    pleaseSelectRating: "Molimo odaberi ocjenu",
    pleaseProvideRating: "Molimo daj ocjenu i potvrdi rezultat",
    youHaveRated: "Već si ocijenio/la ovaj dogovor",
    submitRatingOnly: "Pošalji samo ocjenu",
    submitRating: "Pošalji ocjenu",
    later: "Kasnije",
    ratingSubmitted: "Ocjena uspješno poslana!",
 
    fightResult: "Rezultat borbe",
    win: "Pobjeda",
    loss: "Poraz",
    draw: "Neriješeno",
    noShowFault: "Nedolazak - krivnja",
    noShowMedical: "Nedolazak - medicinski razlog",
    eventCancelled: "Događaj otkazan",
    opponentNoShow: "Protivnik se nije pojavio",
    bonus: "Bonus",
    selectResult: "Odaberi rezultat",
    noResultYet: "Još nema rezultata",
    submitResultOnly: "Pošalji samo rezultat borbe",
    resultSubmitted: "Rezultat poslan",
    submitYourFightResult: "Pošalji svoj rezultat borbe",
    yourFightResult: "Tvoj rezultat borbe",
    description: "Opis",
    submitResult: "Pošalji moj rezultat",
    feedback: "Povratna informacija (maks. 500 znakova)",
    managerConfirmed: "Menadžer je potvrdio rezultat",
    fighterConfirmed: "Borac je potvrdio rezultat",
    manager: "Menadžer",
    fighter: "Borac",
    submitDispute: "Pošalji prigovor",
    disputeSubtitle: "Ako se ne slažeš s rezultatom, pošalji prigovor. Naš tim će pregledati slučaj i donijeti konačnu odluku.",
    submitMyResult: "Pošalji moj rezultat",
    selectResultToSeeAmount: "Odaberi rezultat za prikaz iznosa",
    refundAmount: "Iznos povrata",
    currentResult: "Trenutni rezultat",
    earnings: "Zarada",
    total: "Ukupno",
    breakdown: "Raščlamba",
    note: "Napomena",
    halfBaseAppliedNote: "Primijenjeno je 50% osnovnog iznosa.",
    shareYourExperience: "Podijeli svoje iskustvo...",
    selectYourResult: "Odaberi svoj rezultat",
    drawPayoutWarning: "Odabir neriješenog znači isplatu 50% osnovnog iznosa. Bonus komponente se neće primijeniti.",
    evidence: "Dokazi",
    optional: "Neobavezno",
    charsCount: "{{count}} znakova",
    filesAttached: "{{count}} datoteka priloženo",
    attachImagesOrVideos: "Priloži slike ili videozapise",
    attachImages: "Priloži slike",
    supportedEvidenceFormats: "JPG, PNG, MP4 podržani",
    supportedEvidenceFormatsWithoutVideo: "JPG, PNG podržani",
    explainWhatHappened: "Objasni što se dogodilo...",
    resultUpdated: "Rezultat borbe ažuriran!",
    confirmResult: "Da, potvrđujem",
    rejectresult: "Ne, odbijam",
    giveRating: "Daj ocjenu",
    resultConfirmed: "Rezultat potvrđen!",
    disputeSubmitted: "Prigovor poslan",
    bothConfirmed: "Obje strane potvrdile rezultat",
    resultAlreadySet: "Rezultat je već postavljen",
    chooseOutcome: "Odaberi ishod borbe za prikaz iznosa isplate",
 
    fightResultAndRating: "Rezultat borbe",
    ratingsReceived: "Primljene ocjene",
    anonymous: "Anonimno",
    noRatingsYet: "Još nema ocjena",
    feedbackRequired: "Povratna informacija je obavezna",
    failedToUpdateResult: "Ažuriranje rezultata nije uspjelo",
    failedToConfirmResult: "Potvrda rezultata nije uspjela",
    failedToSubmitDispute: "Slanje prigovora nije uspjelo",
    failedToSubmitRating: "Slanje ocjene nije uspjelo",
    ratingPoor: "Loše",
    ratingFair: "U redu",
    ratingGood: "Dobro",
    ratingVeryGood: "Vrlo dobro",
    ratingExcellent: "Odlično",
    componentLabels: {
      BASE_AMOUNT: "Osnovni iznos",
      PERFORMANCE_BONUS: "Bonus za izvedbu",
      SIGNING_BONUS: "Bonus za potpis",
      TRAVEL_ALLOWANCE: "Putni dodatak",
      APPEARANCE_FEE: "Naknada za nastup",
      WIN_BONUS: "Bonus za pobjedu",
      FIGHT_FEE: "Naknada za borbu",
      TRAVEL_EXPENSE: "Putni troškovi",
      ON_WEIGHT_BONUS: "Bonus za težinu",
      TICKET_COMMISSION: "Provizija za karte",
    },
    paymentTiming: {
      pre_event: "Prije događaja",
      post_event: "Nakon događaja",
    },
    payoutTypes: {
      full: {
        text: "Puna isplata",
        hint: "Sve komponente su primijenjene",
      },
      base_only: {
        text: "Samo osnovni iznos",
        hint: "Bonus komponente su isključene",
      },
      half_base: {
        text: "Pola osnovnog iznosa",
        hint: "Primijenjeno je 50% osnovnog iznosa",
      },
      partial: {
        text: "Djelomična isplata",
        hint: "Neke komponente su isključene",
      },
      none: {
        text: "Bez isplate",
        hint: "Nema isplaćenog iznosa",
      },
    },
    payoutSelectionModes: {
      BASE_PLUS_SELECTED_COMPONENTS: "Osnovica + odabrane komponente",
      SELECTED_COMPONENTS_ONLY: "Samo odabrane komponente",
    },
    cancel: "Odustani",
    ratings: "Ocjene",
    howWasYourExperience: "Kakvo je bilo tvoje iskustvo?",
 
    activityLog: "Dnevnik aktivnosti",
 
    completeAllFields: "Molimo popuni sva obavezna polja",
    resultAndRatingSubmitted: "Rezultat i ocjena uspješno poslani!",
    submissionFailed: "Slanje nije uspjelo. Pokušaj ponovno.",
    downloadFailed: "Preuzimanje nije uspjelo. Pokušaj ponovno.",
 
    noResult: "Nema rezultata",
    failedToRefreshDeal: "Osvježavanje dogovora nije uspjelo",
    paymentSuccessful: "Plaćanje uspješno!",
    failedToLoadDeal: "Učitavanje dogovora nije uspjelo",
    failedToGenerateInvoice: "Izrada računa nije uspjela",
    noPaymentReceiptAvailable: "Potvrda plaćanja nije dostupna",
    failedToDownloadAgreement: "Preuzimanje ugovora nije uspjelo",
    paymentNotAvailableForCheckout: "Ovo plaćanje nije dostupno za naplatu",
    checkoutUrlNotAvailable: "URL za naplatu nije dostupan",
    componentPaymentFailed: "Plaćanje komponente nije uspjelo",
    dealNotFound: "Dogovor nije pronađen",
    back: "Natrag",
    coreInformation: "Osnovne informacije",
    fightDetails: "Detalji borbe",
    dealNotes: "Bilješke dogovora",
    currency: "Valuta",
    paymentMode: "Način plaćanja",
    opponent: "Protivnik",
    numberOfRounds: "Broj rundi",
    ruleset: "Pravilnik",
    componentType: "Vrsta komponente",
    calculationMode: "Način izračuna",
    roundDuration: "Trajanje runde",
    titleFight: "Titularna borba",
    upfront: "Unaprijed",
    split: "Podijeljeno",
    BASE_AMOUNT: "Osnovni iznos",
    activity_PROPOSED: "je predložio dogovor (ID dogovora <b>{{0}}</b>) za sport <b>{{1}}</b> s osnovnim iznosom <b>{{2}}</b> i valutom <b>{{3}}</b>",
    activity_ACCEPTED: "je prihvatio dogovor (ID dogovora <b>{{0}}</b>) s osnovnim iznosom <b>{{1}}</b> valutom <b>{{2}}</b>",
    activity_REJECTED: "je odbio dogovor (ID dogovora <b>{{0}}</b>) s osnovnim iznosom <b>{{1}}</b> valutom <b>{{2}}</b>",
    activity_CANCELLED: "Dogovor je otkazan.",
    activity_CONFIRMED: "Prednatjecajno plaćanje je dovršeno. Dogovor je sada potvrđen.",
    activity_WAITING_FOR_RESULT: "Dogovor čeka na rezultat borbe.",
    activity_RESULT_UPDATED: "je ažurirao rezultat borbe za ID dogovora <b>{{0}}</b> <b>{{1}}</b>",
    activity_RESULT_CONFIRMED: "je ažurirao rezultat borbe za ID dogovora <b>{{0}}</b> <b>{{1}}</b>. Borac je {{2}} rezultat.",
    activity_DISPUTE: "je osporio rezultat borbe za ID dogovora <b>{{0}}</b> <b>{{1}}</b>",
    activity_POST_PAYMENT: "Plaćanje nakon događaja je dovršeno.",
    activity_FIGHTER_RATED: "Borac je poslao svoju ocjenu za ID dogovora <b>{{0}}</b>",
    activity_MANAGER_RATED: "Menadžer je poslao svoju ocjenu za ID dogovora <b>{{0}}</b>",
    activity_FINISHED: "Dogovor je završen. Sve uplate su obrađene.",
    activity_PRE_PAYMENT_RELEASED: "Prednatjecajno plaćanje od <b>{{0}}</b> <b>{{1}}</b> pušteno je borcu.",
    activity_PAYMENT_REFUNDED: "Iznos od <b>{{0}}</b> <b>{{1}}</b> vraćen je menadžeru iz prednatjecajnog plaćanja.",
    activity_POST_PAYMENT_RELEASED: "Plaćanje nakon događaja od <b>{{0}}</b> <b>{{1}}</b> pušteno je borcu.",
    // Pending Messages (hr)
    activity_ACCEPTED_PENDING: "Borac mora prihvatiti dogovor prije roka",
    activity_CONFIRMED_PENDING: "Menadžer mora potvrditi dogovor prije roka",
    activity_RESULT_UPDATED_PENDING: "Menadžer mora ažurirati rezultat borbe prije roka",
    activity_RESULT_CONFIRMED_PENDING: "Borac mora potvrditi rezultat borbe prije roka",
    activity_POST_PAYMENT_PENDING: "Plaćanje nakon događaja čeka na puštanje",
    activity_FIGHTER_RATED_PENDING: "Borac mora poslati ocjenu prije roka",
    activity_MANAGER_RATED_PENDING: "Menadžer mora poslati ocjenu prije roka",
    // System / Auto Messages (hr)
    activity_CANCELLED_DEADLINE_FIGHTER: "Dogovor automatski otkazan — borac nije prihvatio prije roka.",
    activity_CANCELLED_PRE_PAYMENT_OVERDUE: "Dogovor otkazan — prednatjecajno plaćanje nije dovršeno do roka dospijeća.",
    activity_SYSTEM_PAYMENT_RELEASED: "Plaćanje za <b>{{0}}</b> automatski je pušteno od strane sustava.",
    activity_FINISHED_AUTO_DEADLINE: "Dogovor automatski zatvoren — rok za fazu <b>{{0}}</b> je prošao. Sva plaćanja na čekanju su puštena.",
    activity_FINISHED_POST_UNPAID: "Dogovor zatvoren — plaćanje nakon događaja nije primljeno. Prednatjecajno plaćanje pušteno je borcu.",

    // Document Requirement section
    documentRequirement: "Zahtjev za dokument",
    documentType: "Vrsta dokumenta",
    submissionDeadline: "Rok za podnošenje",
    additionalNotesOptional: "Dodatne napomene (neobavezno)",
    uploadStatus: "Status učitavanja",
    uploadedDocument: "Učitani dokument",
    uploadRequiredDocument: "Učitaj potrebni dokument",
    chooseFileAndUploadForDeal: "Odaberite datoteku i učitajte je za ovaj dogovor.",
    selectedFile: "Odabrana datoteka",
    remove: "Ukloni",
    pendingUpload: "Učitavanje na čekanju",
    uploaded: "Učitano",
    deadlineMissed: "Rok propušten",
    pleaseChooseFileFirst: "Molimo prvo odaberite datoteku.",
    dealIdMissing: "Nedostaje ID dogovora.",
    documentUploadNotAllowed: "Učitavanje dokumenta dopušteno je samo osobi koja prihvaća dogovor dok je dogovor u statusu PROPOSED (dokumenti se moraju učitati prije nego što možete prihvatiti dogovor).",
    documentUploadedSuccessfully: "Dokument je uspješno učitan.",
    unableToUploadDocument: "Dokument nije moguće učitati.",
    onlyPdfAllowed: "Za ovaj dokument dopuštene su samo PDF datoteke.",
    uploadingFile: "Učitavanje...",
    uploadButton: "Učitaj",

    // Bonuses, Expenses & Penalties section
    "Bonuses, Expenses & Penalties": "Bonusi, troškovi i kazne",
    "Payout Policies": "Politike isplate",
    category: "Kategorija",
    value: "Vrijednost",
    fundingStage: "Faza financiranja",
    expenseDescription: "Opis troška",

    // kind options
    "Bonus": "Bonus",
    "Expense": "Trošak",
    "Penalty": "Kazna",

    // componentType options
    "Win Bonus": "Bonus za pobjedu",
    "Performance Bonus": "Bonus za nastup",
    "Fight of the Night": "Borba večeri",
    "Performance of the Night": "Nastup večeri",
    "Knockout of the Night": "Nokaut večeri",
    "Submission of the Night": "Predaja večeri",
    "On-Weight Bonus": "Bonus za postignutu težinu",
    "Media & Promo Bonus": "Medijski i promo bonus",
    "Ticket Sales Commission": "Provizija od prodaje ulaznica",
    "PPV Share": "PPV udio",
    "Locker Room Bonus": "Bonus za svlačionicu",
    "Travel Expense": "Putni trošak",
    "Per Diem Expense": "Dnevnica",
    "Late Penalty": "Kazna za kašnjenje",

    // calculation mode options
    "Fixed Amount": "Fiksni iznos",
    "Percentage of Base Amount": "Postotak osnovnog iznosa",

    // funding stage options
    "Pre Event": "Prije događaja",
    "Post Event": "Nakon događaja",

    // Payout Policies outcome labels
    "Win": "Pobjeda",
    "Draw": "Neriješeno",
    "Loss": "Poraz",
    "No-Show Fault": "Nedolazak (krivnja)",
    "No-Show Medical": "Nedolazak (medicinski)",
    "Event Cancelled": "Događaj otkazan",
    "Opponent No-Show": "Protivnik se nije pojavio",

    // Payout Policies selection mode display values
    "Base Plus Selected Components": "Osnovica plus odabrane komponente",
    "Selected Components Only": "Samo odabrane komponente",
  },
};